import {
	Avatar,
	IconButton,
	Menu,
	MenuButton,
	MenuList,
} from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

interface Props {
	children: ReactNode;
	name: string;
	avatarSrc?: string;
	ariaLabel: string;
}

const IconMenu: FC<Props> = ({ children, name, avatarSrc, ariaLabel }) => {
	return (
		<Menu>
			<MenuButton
				as={IconButton}
				size="sm"
				p={0}
				aria-label={ariaLabel}
				data-testid="user-menu-button"
			>
				<Avatar
					aria-hidden
					size="sm"
					src={avatarSrc}
					overflow="hidden"
					name={name}
				/>
			</MenuButton>
			<MenuList>{children}</MenuList>
		</Menu>
	);
};

export default IconMenu;
